import moment from 'moment'
export default function (value, format = 'DD.MM.YYYY') {
  if (!value) {
    return value
  }
  return moment(value).format(format)
}
